<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  background-color: #fff;
}

#app {
  width: 100%;
  min-height: 100vh;
}

.clearfix::after {
  content: '';
  display: table;
  clear: both;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section {
  padding: 60px 0;
}

.section-title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 40px;
  color: #333;
}

.btn {
  display: inline-block;
  padding: 10px 30px;
  background-color: #20b8a7;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.btn:hover {
  background-color: #1a9a8b;
}
</style>
